import { UserSaysTab } from './UserSaysTab'

export default UserSaysTab
